import React, { useEffect, useRef, useState } from "react";
import { GridConfig, NewTaskBugConfig } from "./NewTaskBug.Data";

import "./NewTaskBug.scss";
import SwalAlert from "../../../../../../services/swalService/SwalService";
import { useAddTaskBugMutation, useLazyGetBugTaskByTaskIdQuery } from "../../../../../../app/services/bugTaskAPI";
import { useDeleteTaskMutation } from "../../../../../../app/services/taskAPI";
import { encryptUrlData } from "../../../../../../services/CryptoService";
import ToastService from "../../../../../../services/toastService/ToastService";
import MolGrid from "../../../../../../components/grid/MolGrid";
import CenterModel from "../../../../../../components/ui/centerModel/CenterModel";
import FormCreator from "../../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../../components/ui/button/Buttons";
import IconButton from "../../../../../../components/ui/iconbutton/IconButton";

const NewTaskBug = ({ taskId, projectId }) => {
  const bugRef = useRef();
  const { confirm } = SwalAlert();
  const [showPopup, setShowPopup] = useState(false);

  const molGridRef = useRef();
  const [bugForm] = useState(NewTaskBugConfig);
  const [dataSource, setDataSource] = useState([]);

  const [
    getBugTaskByTaskId,
    {
      isFetching: isgetBugTaskByTaskIdFetching,
      isSuccess: isgetBugTaskByTaskIdListSuccess,
      data: getBugTaskByTaskIdData,
    },
  ] = useLazyGetBugTaskByTaskIdQuery();

  const [addTaskBug, { isSuccess: isaddTaskBugSuccess, data: addTaskBugData }] =
    useAddTaskBugMutation();

  const [deleteTask, { isSuccess: isDeleteSuccess, data: TaskDataDelete }] =
    useDeleteTaskMutation();

  useEffect(() => {
    if (taskId) {
      getBugTaskByTaskId(taskId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);


  useEffect(() => {
    if (isgetBugTaskByTaskIdListSuccess && getBugTaskByTaskIdData) {
      if (getBugTaskByTaskIdData) {
        setDataSource(getBugTaskByTaskIdData);
      }
    }
  }, [isgetBugTaskByTaskIdListSuccess, getBugTaskByTaskIdData]);

  const handleEditClick = (taskId) => {
    const dataURL = {};
    dataURL.taskId = taskId.taskId;
    dataURL.projectId = projectId;
    window.open(`/project/EditTask/${encryptUrlData(dataURL)}}`, "_blank");
  };

  const onDeleteAction = (taskId) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteTask(taskId.taskId);
      }
    });
  };

  useEffect(() => {
    if (isDeleteSuccess && TaskDataDelete) {
      ToastService.success(TaskDataDelete.errorMessage);
      getBugTaskByTaskId(taskId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteSuccess && TaskDataDelete]);

  const closePopup = () => {
    setShowPopup(false);
  };
  const handleOpenPopup = () => {
    setShowPopup(true);
  };
  const handleSubmit = () => {
    let bugData = bugRef.current.getFormData();
    if (bugData) {
      const requestData = {
        ...bugData,
        taskId: taskId,
        title: bugData.title,
        description: bugData.description,
      };
      addTaskBug(requestData);
    }
  };

  useEffect(() => {
    if (isaddTaskBugSuccess && addTaskBugData) {
      if (addTaskBugData.errorMessage.includes("exists")) {
        ToastService.warning(addTaskBugData.errorMessage);
        return;
      } else {
        ToastService.success(addTaskBugData.errorMessage);
        closePopup();
        getBugTaskByTaskId(taskId);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isaddTaskBugSuccess, addTaskBugData]);

  const actionHandler = {
    EDIT: handleEditClick,
    DELETE: onDeleteAction,
  };

  return (
    <>
      <div className="new-bug-list">
        <div className="task-title-sec">
          <div className="referencetask-label">Bugs List :</div>
          {/* <Buttons
            buttonTypeClassName={"theme-btn"}
            onClick={handleOpenPopup}
            buttonText={"Attach Task"}
            textWithIcon={true}
            fontIcon={true}
            iconName={"akar-icons:link-chain"}
            titleText={"Refresh"}
          /> */}
          <IconButton size="small" icon="ic:round-add" shape="square" onClick={handleOpenPopup} />
        </div>
        {/* <CardSection
          cardTitle={"Bugs List"}
          buttonClassName="theme-btn"
          rightButton={true}
          buttonText="Bug"
          textWithIcon={true}
          iconName="ic:round-add"
          fontIcon={true}
          titleButtonClick={handleOpenPopup}
        >
          
        </CardSection> */}
        <div className="new-bug-list-body">
          <MolGrid
            dataSource={dataSource}
            ref={molGridRef}
            configuration={GridConfig}
            allowPagination={false}
            isLoading={isgetBugTaskByTaskIdFetching}
            onActionChange={actionHandler}
          />
        </div>
      </div>
      {showPopup && (
        <CenterModel
          showModal={showPopup}
          className="header-task-center-model"
          handleToggleModal={closePopup}
          modalTitle={`Create Bug TM ${taskId}`}
          modelSizeClass="w-40"
        >
          <FormCreator config={bugForm} ref={bugRef} {...bugForm} />
          <div className="d-flex justify-content-end">
            <Buttons
              buttonTypeClassName="dark-btn"
              buttonText="Cancel"
              onClick={closePopup}
            />
            <Buttons
              buttonTypeClassName="theme-btn ml-4"
              buttonText="Save"
              onClick={handleSubmit}
            />
          </div>
        </CenterModel>
      )}
    </>
  );
};

export default NewTaskBug;
